'use strict';
const Annotate = {
  isAnnotationStarted: false,
  canvasOptions: { width: 0, height: 0 },
  annotationConfig: {
    toolType: 'draw',
    isErase: false,
    drawMethod: 'pencil',
    strokeColor: '#ff0000',
    lineWidth: 3,
    hasInput: false,
    lastMouseX: 0,
    lastMouseY: 0,
    canvasX: 0,
    canvasY: 0,
    mouseX: 0,
    mouseY: 0,
    mouseDown: false,
    drawElement: null,
    drawCtx: null,
    canvasDomID: null,
    canvasVideoPlayerID: null,
    customCanvasID: 'draw_veneer2',
  },

  setupAnnotationToolbar () {
    const toolbarCont = document.createElement('div');
    toolbarCont.setAttribute('id', 'annotationToolbarContainer');
    toolbarCont.style = 'position: absolute;bottom: 0; z-index: 98;';
    const toolbar = document.createElement('div');
    toolbar.setAttribute('id', 'toolbar');
    toolbar.innerHTML = `<div class="atn-btns">
      <button id="annotate-draw">Draw</button>
      <select id="selDrawMethod">
        <option value="pencil" selected="selected">Pencil</option>
        <option value="text">Text</option>
      </select>
      <input
      type="color"
      id="favcolor"
      name="favcolor"
      value="#ff0000"
      
    />
    <select id="selWidth" >
      <option value="1">1</option>
      <option value="3" selected="selected">3</option>
      <option value="5">5</option>
      <option value="7">7</option>
      <option value="9">9</option>
      <option value="11">11</option>
    </select>
    <input type="button" id="eraseBtn" value="Erase"  />
    <input type="button" id="clearBtn" value="Clear"  />
      </div>`;
    toolbarCont.append(toolbar);
    // this.bindEventListernersForTools()
    return { toolbarCont, toolbar };
  },

  _QS(domSelector, all = false) {
    if (all) {
      return document.querySelectorAll(`${domSelector}`) ? document.querySelectorAll(`${domSelector}`) : false;
    }
    return document.querySelector(`${domSelector}`) ? document.querySelector(`${domSelector}`) : false;


  },
  bindEventListernersForTools() {
    let _this = this;
    if (_this._QS('#annotate-draw')) {
      _this._QS('#annotate-draw').addEventListener("click", (e) => {
        _this.annotateToolAction('tool', 'draw')
      })
    }
    if (_this._QS('#selDrawMethod')) {
      _this._QS('#selDrawMethod').addEventListener("change", (e) => {
        _this.annotateToolAction('drawMethod', e.target.value)
      })
    }
    if (_this._QS('#selWidth')) {
      _this._QS('#selWidth').addEventListener("change", (e) => {
        _this.annotateToolAction('lineWidth', e.target.value)
      })
    }
    if (_this._QS('#favcolor')) {
      _this._QS('#favcolor').addEventListener("change", (e) => {
        _this.annotateToolAction('strokeColor', e.target.value)
      })
    }
    if (_this._QS('#eraseBtn')) {
      _this._QS('#eraseBtn').addEventListener("click", (e) => {
        _this.annotateToolAction('erase')
      })
    }
    if (_this._QS('#clearBtn')) {
      _this._QS('#clearBtn').addEventListener("click", (e) => {
        _this.annotateToolAction('clear')
      })
    }
  },

  annotateAddInput(x, y) {
    let _this = this;
    const input = document.createElement('input');
    input.className = 'annotate-text';
    input.type = 'text';
    input.style.position = 'fixed';
    input.style.zIndex = 50;
    input.style.left = `${x - 4}px`;
    input.style.top = `${y - 4}px`;
    input.onkeydown = function(e){
      const keyCode = e.keyCode;
      if (keyCode === 13) {
        _this.annotateDrawText(e.target.value);
        document.body.removeChild(e.target);
        _this.annotationConfig.hasInput = false;
      } else if (keyCode === 27) {
        document.body.removeChild(e.target);
        _this.annotationConfig.hasInput = false;
      }
    };
    document.body.appendChild(input);
    input.focus();
    this.annotationConfig.hasInput = true;
  },

  handleEnter(e) {
    let _this = this;
    const keyCode = e.keyCode;
    if (keyCode === 13) {
      _this.annotateDrawText(e.target.value);
      document.body.removeChild(e.target);
      _this.annotationConfig.hasInput = false;
    } else if (keyCode === 27) {
      document.body.removeChild(e.target);
      _this.annotationConfig.hasInput = false;
    }
  },

  annotateDrawText(txt) {
    let _this = this;
    _this.annotationConfig.drawCtx.textBaseline = 'top';
    _this.annotationConfig.drawCtx.textAlign = 'left';
    _this.annotationConfig.drawCtx.fillStyle = _this.annotationConfig.strokeColor;
    _this.annotationConfig.drawCtx.font = '14px sans-serif';
    _this.annotationConfig.drawCtx.fillText(
      txt,
      _this.annotationConfig.lastMouseX - 4,
      _this.annotationConfig.lastMouseY - 4,
    );
  },

  reOffset(selector) {
    let _this = this;
    const canvasData = selector.getBoundingClientRect();
    _this.annotationConfig.canvasX = canvasData.left;
    _this.annotationConfig.canvasY = canvasData.top;
  },

  toolBarAction(action, value) {
    let _this = this;
    if (action === 'tool') {
      _this.annotationConfig.toolType = value;
      _this.annotationConfig.isErase = false;
    } else if (action === 'erase') {
      _this.annotationConfig.toolType = action;
      _this.annotationConfig.isErase = true;
    } else if (action === 'strokeColor') {
      _this.annotationConfig.strokeColor = value;
    } else if (action === 'lineWidth') {
      _this.annotationConfig.lineWidth = value;
    } else if (action === 'drawMethod') {
      _this.annotationConfig.drawMethod = value;
    } else if (action === 'clear') {
      const elements = document.getElementsByClassName('annotate-text');
      while (elements.length > 0) {
        elements[0].remove();
      }
      _this.annotationConfig.drawCtx.clearRect(
        0,
        0,
        _this.canvasOptions.width,
        _this.canvasOptions.height,
      );
    }
  },

  appendCustomCanvas(wrapper, className, width, height) {
    let _this = this;
    _this.canvasOptions.width = width;
    _this.canvasOptions.height = height;
    const drawcanvas = document.createElement('canvas');
    drawcanvas.id = _this.annotationConfig.customCanvasID;
    drawcanvas.width = width;
    drawcanvas.height = height;
    drawcanvas.className = className;
    drawcanvas.setAttribute('style', 'display:block; user-select: none;z-index:5000;');
    wrapper.append(drawcanvas);
    const { toolbarCont, toolbar } = _this.setupAnnotationToolbar();
    wrapper.append(toolbarCont);

  },

  onDown(e, touch) {
    let _this = this;

    e.preventDefault();
    var clientX, clientY;
    if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
      var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
      var touch = evt.touches[0] || evt.changedTouches[0];
      clientX = touch.pageX;
      clientY = touch.pageY;
    } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover' || e.type == 'mouseout' || e.type == 'mouseenter' || e.type == 'mouseleave') {
      clientX = e.clientX;
      clientY = e.clientY;
    }

    _this.reOffset(_this.annotationConfig.drawElement);
    _this.annotationConfig.lastMouseX = _this.annotationConfig.mouseX = parseInt(clientX - _this.annotationConfig.canvasX);
    _this.annotationConfig.lastMouseY = _this.annotationConfig.mouseY = parseInt(clientY - _this.annotationConfig.canvasY);
    _this.annotationConfig.mouseDown = true;
    if (
      _this.annotationConfig.drawMethod === 'text' &&
      _this.annotationConfig.toolType === 'draw'
    ) {
      _this.annotateAddInput(clientX, clientY);
    }
  },

  onMove(e, inputContext, touch) {
    let _this = this;
    e.preventDefault();
    var clientX, clientY;
    if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel') {
      var evt = (typeof e.originalEvent === 'undefined') ? e : e.originalEvent;
      var touch = evt.touches[0] || evt.changedTouches[0];
      clientX = touch.pageX;
      clientY = touch.pageY;
    } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover' || e.type == 'mouseout' || e.type == 'mouseenter' || e.type == 'mouseleave') {
      clientX = e.clientX;
      clientY = e.clientY;
    }


    _this.annotationConfig.mouseX = parseInt(clientX - _this.annotationConfig.canvasX);
    _this.annotationConfig.mouseY = parseInt(clientY - _this.annotationConfig.canvasY);

    if (_this.annotationConfig.mouseDown && _this.annotationConfig.drawMethod === 'pencil') {

      _this.annotationConfig.drawCtx.beginPath();
      if (_this.annotationConfig.toolType === 'draw') {
        _this.annotationConfig.drawCtx.globalCompositeOperation = 'source-over';
        _this.annotationConfig.drawCtx.strokeStyle = _this.annotationConfig.strokeColor;
        _this.annotationConfig.drawCtx.lineWidth = _this.annotationConfig.lineWidth;
      } else {
        _this.annotationConfig.drawCtx.globalCompositeOperation = 'destination-out';
        _this.annotationConfig.drawCtx.lineWidth = 10;
      }

      _this.annotationConfig.drawCtx.moveTo(
        _this.annotationConfig.lastMouseX,
        _this.annotationConfig.lastMouseY,
      );
      _this.annotationConfig.drawCtx.lineTo(
        _this.annotationConfig.mouseX,
        _this.annotationConfig.mouseY,
      );
      _this.annotationConfig.drawCtx.lineJoin = inputContext.lineCap = 'round';
      _this.annotationConfig.drawCtx.stroke();
    }
    _this.annotationConfig.lastMouseX = _this.annotationConfig.mouseX;
    _this.annotationConfig.lastMouseY = _this.annotationConfig.mouseY;
  },

  onUp(e) {
    e.preventDefault();
    this.annotationConfig.mouseDown = false;
  },

  annotateToolAction(action, value) {
    this.toolBarAction(action, value);
  },

  /*Draw on mouse move*/
   mouseAnnotate (canvasDomID, inputContext, canvasVideoPlayerID) {
    let _this = this;
    _this.isAnnotationStarted = true;
    _this.annotationConfig.drawElement = document.getElementById(_this.annotationConfig.customCanvasID);
    _this.annotationConfig.drawCtx = _this.annotationConfig.drawElement.getContext('2d');
    _this.annotationConfig.canvasDomID = canvasDomID;
    _this.annotationConfig.canvasVideoPlayerID = canvasVideoPlayerID;

    //on onmousedown
    _this.annotationConfig.drawElement.addEventListener('mousedown', (e) => {
      _this.onDown(e, false);

    });
    _this.annotationConfig.drawElement.addEventListener('touchstart', (e) => {
      _this.onDown(e, true);
    });

    //on onmousemove
    _this.annotationConfig.drawElement.addEventListener('mousemove', (e) => {
      _this.onMove(e, inputContext, false);
    });
    _this.annotationConfig.drawElement.addEventListener('touchmove', (e) => {
      _this.onMove(e, inputContext, true);
    });

    //on mouseup
    _this.annotationConfig.drawElement.addEventListener('mouseup', (e) => {
      _this.onUp(e);
    });
    _this.annotationConfig.drawElement.addEventListener('touchcancel', (e) => {
      _this.onUp(e);
    });
    return _this.annotationConfig.drawElement;
  },

  stopAnnotation()  {
    let _this = this;
    _this.isAnnotationStarted = false;
    const canvasWrapper = document.getElementById('canvas-wrapper');
    if (canvasWrapper) canvasWrapper.remove();
    const elements = document.getElementsByClassName('annotate-text');
    while (elements.length > 0) {
      elements[0].remove();
    }
    _this.annotationConfig.toolType = 'draw';
    _this.annotationConfig.isErase = false;
    _this.annotationConfig.drawMethod = 'pencil';
    _this.annotationConfig.strokeColor = '#ff0000';
    _this.annotationConfig.lineWidth = 3;
  },

  resize() {
    let _this = this;
    if (_this.isAnnotationStarted) {
      setTimeout(() => {
        const drawCanvas = document.getElementById(_this.annotationConfig.customCanvasID);
        const streamCanvas = document.getElementById(_this.annotationConfig.canvasDomID);
        const videoCanvas = document.getElementById(_this.annotationConfig.canvasVideoPlayerID);
        drawCanvas.width = videoCanvas.clientWidth;
        drawCanvas.height = videoCanvas.clientHeight;
        streamCanvas.width = videoCanvas.clientWidth;
        streamCanvas.height = videoCanvas.clientHeight;
        _this.reOffset(_this.annotationConfig.drawElement);
      }, 100);
    }
  }
}

window.addEventListener('resize', Annotate.resize());

export default Annotate;



//////////////////
// WEBPACK FOOTER
// ./src/annotate.js
// module id = 203
// module chunks = 0